export class MyHTTPConnection {
  static HTTP_URL = 'https://ebus.science/api/';
}
